import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, element, attr, insert, append, listen, noop, detach, text, space, empty, set_data } from '../../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../../i18n.js';
import { isIngame } from '../../../external_node_modules/@wg/web2clientapi/utils/checkIngame.js';
import { openExternalUrl } from '../../../external_node_modules/@wg/web2clientapi/browser/openExternalUrl.js';
import { disableBodyOverflow } from '../../../utils/disableBodyOverflow.js';
import PurchaseRestrictionPopup from '../../shared/components/PurchaseRestrictionPopup/PurchaseRestrictionPopup.svelte.js';
import '../../shared/components/PurchaseRestrictionPopup/assets/styles/purchaseRestriction.scss.js';
import { error } from '../../../utils/logger.js';

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case '../../../../public/countries/cs.js': return import('../../../public/countries/cs.js');
    case '../../../../public/countries/de.js': return import('../../../public/countries/de.js');
    case '../../../../public/countries/en.js': return import('../../../public/countries/en.js');
    case '../../../../public/countries/es-mx.js': return import('../../../public/countries/es-mx.js');
    case '../../../../public/countries/es.js': return import('../../../public/countries/es.js');
    case '../../../../public/countries/fr.js': return import('../../../public/countries/fr.js');
    case '../../../../public/countries/it.js': return import('../../../public/countries/it.js');
    case '../../../../public/countries/ja.js': return import('../../../public/countries/ja.js');
    case '../../../../public/countries/ko.js': return import('../../../public/countries/ko.js');
    case '../../../../public/countries/pl.js': return import('../../../public/countries/pl.js');
    case '../../../../public/countries/pt-br.js': return import('../../../public/countries/pt-br.js');
    case '../../../../public/countries/ru.js': return import('../../../public/countries/ru.js');
    case '../../../../public/countries/th.js': return import('../../../public/countries/th.js');
    case '../../../../public/countries/tr.js': return import('../../../public/countries/tr.js');
    case '../../../../public/countries/zh-tw.js': return import('../../../public/countries/zh-tw.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function create_if_block(ctx) {
	let div;
	let button;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			button = element("button");
			button.textContent = `${t('Перейти в центр поддержки')}`;
			attr(button, "class", "purchase-restriction-button purchase-restriction-button--outline");
			attr(div, "class", "purchase-restriction__action");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, button);

			if (!mounted) {
				dispose = listen(button, "click", /*openSupportPage*/ ctx[6]);
				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			dispose();
		}
	};
}

// (54:2) <svelte:fragment slot="purchase-restriction-content">
function create_purchase_restriction_content_slot(ctx) {
	let div0;
	let t0_value = t('Указанная вами страна магазина ({countryText}) не совпадает со страной регистрации ({spaCountryText}).').replace('{countryText}', /*countryText*/ ctx[4]).replace('{spaCountryText}', /*spaCountryText*/ ctx[5]) + "";
	let t0;
	let t1;
	let div1;
	let t3;
	let div2;
	let t5;
	let if_block_anchor;
	let if_block = /*userSupportUrl*/ ctx[2] && create_if_block(ctx);

	return {
		c() {
			div0 = element("div");
			t0 = text(t0_value);
			t1 = space();
			div1 = element("div");
			div1.textContent = `${t('Предложения магазина, способы оплаты и валюта зависят от страны регистрации.')}`;
			t3 = space();
			div2 = element("div");
			div2.textContent = `${t('Пожалуйста, обратитесь в Центр Поддержки Пользователей, для изменения страны регистрации и совершения покупок по ценам, действительным для нее.')}`;
			t5 = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			attr(div0, "class", "purchase-restriction__text");
			attr(div1, "class", "purchase-restriction__text");
			attr(div2, "class", "purchase-restriction__text");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			append(div0, t0);
			insert(target, t1, anchor);
			insert(target, div1, anchor);
			insert(target, t3, anchor);
			insert(target, div2, anchor);
			insert(target, t5, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*countryText, spaCountryText*/ 48 && t0_value !== (t0_value = t('Указанная вами страна магазина ({countryText}) не совпадает со страной регистрации ({spaCountryText}).').replace('{countryText}', /*countryText*/ ctx[4]).replace('{spaCountryText}', /*spaCountryText*/ ctx[5]) + "")) set_data(t0, t0_value);

			if (/*userSupportUrl*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div0);
			if (detaching) detach(t1);
			if (detaching) detach(div1);
			if (detaching) detach(t3);
			if (detaching) detach(div2);
			if (detaching) detach(t5);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let purchaserestrictionpopup;
	let current;

	purchaserestrictionpopup = new PurchaseRestrictionPopup({
			props: {
				purchaseRestrictionId: /*purchaseRestrictionId*/ ctx[0],
				isClosable: /*isClosable*/ ctx[1],
				closeApplication: /*closeApplication*/ ctx[3],
				purchaseRestrictionAction: /*openSupportPage*/ ctx[6],
				$$slots: {
					"purchase-restriction-content": [create_purchase_restriction_content_slot]
				},
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(purchaserestrictionpopup.$$.fragment);
		},
		m(target, anchor) {
			mount_component(purchaserestrictionpopup, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const purchaserestrictionpopup_changes = {};
			if (dirty & /*purchaseRestrictionId*/ 1) purchaserestrictionpopup_changes.purchaseRestrictionId = /*purchaseRestrictionId*/ ctx[0];
			if (dirty & /*isClosable*/ 2) purchaserestrictionpopup_changes.isClosable = /*isClosable*/ ctx[1];
			if (dirty & /*closeApplication*/ 8) purchaserestrictionpopup_changes.closeApplication = /*closeApplication*/ ctx[3];

			if (dirty & /*$$scope, userSupportUrl, countryText, spaCountryText*/ 2100) {
				purchaserestrictionpopup_changes.$$scope = { dirty, ctx };
			}

			purchaserestrictionpopup.$set(purchaserestrictionpopup_changes);
		},
		i(local) {
			if (current) return;
			transition_in(purchaserestrictionpopup.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(purchaserestrictionpopup.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(purchaserestrictionpopup, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { purchaseRestrictionId } = $$props;
	let { isClosable } = $$props;
	let { language } = $$props;
	let { country } = $$props;
	let { spaCountry } = $$props;
	let { userSupportUrl } = $$props;
	let { closeApplication } = $$props;
	let countryText = country;
	let spaCountryText = spaCountry;

	function openSupportPage() {
		if (isIngame()) {
			return openExternalUrl(userSupportUrl);
		}

		window.open(userSupportUrl);
	}

	async function loadCountry(language, country, spaCountry) {
		try {
			const { default: countries } = await __variableDynamicImportRuntime0__(`../../../../public/countries/${language}.js`);
			country = country.toUpperCase();
			spaCountry = spaCountry.toUpperCase();
			$$invalidate(4, countryText = countries[country] || country);
			$$invalidate(5, spaCountryText = countries[spaCountry] || spaCountry);
		} catch(err) {
			error('Error load country names');
		}
	}

	disableBodyOverflow(true);
	loadCountry(language, country, spaCountry);

	$$self.$$set = $$props => {
		if ('purchaseRestrictionId' in $$props) $$invalidate(0, purchaseRestrictionId = $$props.purchaseRestrictionId);
		if ('isClosable' in $$props) $$invalidate(1, isClosable = $$props.isClosable);
		if ('language' in $$props) $$invalidate(7, language = $$props.language);
		if ('country' in $$props) $$invalidate(8, country = $$props.country);
		if ('spaCountry' in $$props) $$invalidate(9, spaCountry = $$props.spaCountry);
		if ('userSupportUrl' in $$props) $$invalidate(2, userSupportUrl = $$props.userSupportUrl);
		if ('closeApplication' in $$props) $$invalidate(3, closeApplication = $$props.closeApplication);
	};

	return [
		purchaseRestrictionId,
		isClosable,
		userSupportUrl,
		closeApplication,
		countryText,
		spaCountryText,
		openSupportPage,
		language,
		country,
		spaCountry
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			purchaseRestrictionId: 0,
			isClosable: 1,
			language: 7,
			country: 8,
			spaCountry: 9,
			userSupportUrl: 2,
			closeApplication: 3
		});
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
